import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../common/html/checkbox'
import { deleteTypes } from '../constant'
import {
  checkAllItem,
  checkItem,
  selectById,
  selectChecked,
  selectDeleteType,
  selectIds,
  uncheckAllItem,
} from './store/slice'

const CheckboxAll = ({ defaultTemplate, idKey }) => {
  const dispatch = useDispatch()

  const ids = useSelector(selectIds)
  const checked = useSelector(selectChecked)
  const byId = useSelector(selectById)
  const deleteType = useSelector(selectDeleteType)

  const onChange = (valChecked) => {
    const actionTrue = isDeleteIn ? checkAllItem : uncheckAllItem
    const actionFalse = isDeleteIn ? uncheckAllItem : checkAllItem

    if (valChecked) {
      dispatch(actionTrue())
    } else {
      dispatch(actionFalse())
    }

    if (!isDeleteIn && defaultTemplate[idKey]) {
      dispatch(checkItem(defaultTemplate[idKey]))
    }
  }

  const isDeleteIn = deleteType === deleteTypes.IN
  const isChecked = isDeleteIn
    ? !ids.some(
        (id) =>
          !checked[id] && !byId[id].isDefault && !byId[id].isFiinGateTemplate,
      )
    : !ids.some(
        (id) =>
          checked[id] && !byId[id].isDefault && !byId[id].isFiinGateTemplate,
      )

  return <Checkbox checked={isChecked} onChange={onChange} />
}

export default CheckboxAll
